import { useState } from 'react';
import OTPInput from 'otp-input-react';
import LoginDialogHeader from '../../Components/CommonComponents/LoginDialogHeader';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import authService from '../../Services/authService';
import { toast } from 'react-hot-toast';
import Progress from '../../Components/CommonComponents/Progress';
import { useLayoutStore } from 'Store/LayoutStore';
import { filterMenusWithPermissions } from 'Utilities/componentSpecificUtilities';
import { menus, adminMenus } from 'ServiceHooks/authHooks';
import { FULL_MENU_LIST } from 'Utilities/constants';
import { isEmpty } from 'lodash';
const VerifyOTP = () => {
  const [OTP, setOTP] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect_url = searchParams.get('redirect_url');
  const [isprogress, setProgress] = useState(false);
  const {
    toggleNotification,
    setGridColumnPreference,
    setDashboardPreference,
  } = useLayoutStore((state) => ({
    toggleNotification: state.toggleNotification,
    setGridColumnPreference: state.setGridColumnPreference,
    setDashboardPreference: state.setDashboardPreference,
  }));
  const verifyOtpData = () => {
    if (OTP.length === 6) {
      sendOTP(OTP);
    } else {
      toast.error('Please Enter OTP');
      // toast((t) => (
      //   <span>

      //     <button onClick={() => toast.dismiss(t.id)}>
      //       Dismiss
      //     </button>
      //   </span>
      // ));
    }
  };

  const sendOTP = async (OTP) => {
    setProgress(true);
    var data = {
      otp: OTP,
    };
    await authService
      .verifyOtp(data)
      .then(
        async (oResponse) => {
          const authData = oResponse.data.data;
          // localStorage.setItem('user', JSON.stringify(authData));
          await Promise.all([
            localStorage.setItem('user', JSON.stringify(authData)),
            localStorage.setItem('email', authData.email),
            localStorage.setItem('userId', authData.user_id),
            localStorage.setItem(
              'mobile_number',
              JSON.stringify(authData.mobile_number),
            ),
          ]);
          toggleNotification(true);
          if (!isEmpty(authData?.custom_table_settings)) {
            setGridColumnPreference(authData?.custom_table_settings);
          }
          if (!isEmpty(authData?.dashboard_drag_and_drop_permissions)) {
            setDashboardPreference(
              authData?.dashboard_drag_and_drop_permissions,
            );
          }
          const menuType = authData.is_superadmin ? adminMenus : menus;
          const permissions = authData.permissions;
          const permittedMenu = filterMenusWithPermissions(
            permissions,
            menuType,
            FULL_MENU_LIST,
          );
          toast.success('OTP Verified');
          console.log(redirect_url, 'redirect_url');
          if (redirect_url && redirect_url !== 'null') {
            const decoded = jwtDecode(redirect_url);
            if (decoded?.status === 'REVIEW_PENDING') {
              navigate(`/hr/interviewer/?redirect_url=${redirect_url}`);
              // navigate(0);
            }
          } else {
            navigate(permittedMenu[0].menuLink);
            // navigate(0);
          }
          setProgress(false);
        },
        (error) => {
          const errorMessage = error.response.data.error_info.otp;
          toast.error(errorMessage);
          setProgress(false);
        },
      )
      .catch((err) => {
        console.log(err);
        setProgress(false);
      });
  };

  return (
    <LoginDialogHeader>
      <div className="login">
        <OTPInput
          value={OTP}
          onChange={setOTP}
          autoFocus
          OTPLength={6}
          otpType="number"
        />
        <button onClick={() => verifyOtpData()}>Verify OTP</button>
      </div>
      {isprogress && <Progress />}
    </LoginDialogHeader>
  );
};
export default VerifyOTP;
